// extracted by mini-css-extract-plugin
export default {"melodyVideo":"XJ-z","isFullWidth":"YJ-z","landingPageVideo":"ZJ-z","play":"_J-z","iframeVideo":"aK-z","playHidden":"bK-z","fullwidth":"cK-z"};